
export default (width = 24, height = 22, color = '#E65050') => `
<svg width="${width}" height="${height}" viewBox="0 0 24 22" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
        <path d="M13.429 1.262l10.29 18.35a1.5 1.5 0 0 1-1.308 2.234H1.83a1.5 1.5 0 0 1-1.309-2.234l10.29-18.35a1.5 1.5 0 0 1 2.617 0z" fill="${color}"/>
        <g fill="#FFF">
            <path d="M12.202 19.756c-.954 0-1.743-.76-1.743-1.743 0-1.013.817-1.744 1.743-1.744.98 0 1.743.731 1.743 1.744 0 .985-.764 1.743-1.743 1.743zM12.836 14.185c-.16.734-1.1.746-1.268 0-.168-.745-1.11-4.125-1.11-6.246 0-1.412 1.059-2.14 1.718-2.128.647.011 1.77.736 1.77 2.128-.001 2.134-.943 5.483-1.11 6.246z"/>
        </g>
    </g>
</svg>
`
